<ws-modal-wrapper [headerLabel]="modalTitle"
                  (save)="save()"
                  (cancel)="cancel()"
                  [useAceStyles]="true">
    <div class="row">
        <div class="col-md-10">
            <label style="margin-right: 20px;">
                Display Type:
            </label>
            <div class="radio" style="display: inline-block;">
                <label>
                    <input type="radio"
                           name="display-type-criteria"
                           [(ngModel)]="search.defaultDisplay"
                           [value]="defaultDisplayTypes.CRITERIA">
                    Filter
                </label>
            </div>
            <div class="radio" style="display: inline-block; margin-left: 20px;">
                <label>
                    <input type="radio"
                           name="display-type-results"
                           [(ngModel)]="search.defaultDisplay"
                           [value]="defaultDisplayTypes.RESULTS">
                    Detailed List
                </label>
            </div>
        </div>
    </div>
</ws-modal-wrapper>
